<div class="modal-backdrop" (click)="onClose()"></div>

<div class="upi-transfer-container" (click)="$event.stopPropagation()">
	<!-- Floating Recipient Badge (Steps 2 & 3) -->
	@if (step() === 2 || step() === 3) {
	<div class="recipient-badge-floating">
		<div class="avatar">{{ recipientInitial() }}</div>
		<div class="details">
			<div class="name">{{ recipientName() }}</div>
			<div class="upi">Account: {{ transferDetails().accountNumber }}</div>
		</div>
	</div>
	}

	<div class="card-stack" [class.compact-mode]="step() >= 3" [class.success-mode]="step() === 5">
		<!-- Header Card -->
		@if (step() !== 5) {
		<div class="upi-header-card">
			<div class="upi-header-content">
				<h2 class="title">
					@if (step() <= 3) { To Bank Account } @else if (step()===4) { Security } @else { Successfully! }
						</h2>
			</div>

			<!-- Step Indicator -->
			@if (step() <= 3) { <div class="step-indicator-wrapper">
				<span class="step-label">Step {{ step() }} of 3</span>
				@if (step() === 1) {
				<img src="assets/icons/step-zero.svg" alt="step progress" class="step-progress-img">
				} @else {
				<div class="progress-container">
					<div class="segment" [class.filled]="step() > 1"></div>
					<div class="segment" [class.filled]="step() > 2"></div>
					<div class="segment" [class.filled]="step() > 3"></div>
				</div>
				}
		</div>
		}

		<!-- Final Label -->
		@if (step() === 4) {
		<div class="step-indicator-wrapper">
			<span class="step-label">Final</span>
			<div class="progress-container">
				<div class="segment filled"></div>
				<div class="segment filled"></div>
				<div class="segment filled"></div>
			</div>
		</div>
		}
		@if (step() !== 4) {
		<div class="close-action-wrapper" (click)="onClose()">
			<div class="close-icon-container">
				<img src="assets/icons/img_remove.svg" alt="close">
			</div>
		</div>
		}
	</div>
	}

	<!-- Body Card -->
	<div class="upi-body-card" [class.success-body]="step() === 5">
		<form class="upi-body-inner" [class.no-padding]="step() === 5" [formGroup]="form"
			(submit)="$event.preventDefault()" novalidate>
			<!-- Hidden username for Accessibility/Password Managers -->
			<input type="text" autocomplete="username" style="display:none" aria-hidden="true" value="Current User">

			<!-- Step 1: Recipient Details (Bank Account Specific) -->
			@if (step() === 1) {
			<div class="step-main-heading">Recipient details</div>

			<div class="bank-account-form-grid">
				<div class="upi-input-group">
					<div class="label-row">Recipient Name</div>
					<div class="input-box" [class.error]="isFieldInvalid('recipientName')">
						<input type="text" placeholder="Enter recipient name" formControlName="recipientName"
							autocomplete="name">
					</div>
					@if (isFieldInvalid('recipientName')) {
					<div class="error-message">{{ getFieldError('recipientName') }}</div>
					}
				</div>

				<div class="upi-input-group">
					<div class="label-row">Account Number</div>
					<div class="input-box" [class.error]="isFieldInvalid('accountNumber')">
						<input type="text" placeholder="Enter account number" formControlName="accountNumber"
							maxlength="18" autocomplete="off" (input)="formatAccountNumber($event)">
					</div>
					@if (isFieldInvalid('accountNumber')) {
					<div class="error-message">{{ getFieldError('accountNumber') }}</div>
					}
				</div>

				<div class="upi-input-group full-width">
					<div class="label-row">IFSC Code</div>
					<div class="input-box" [class.error]="isFieldInvalid('ifscCode')">
						<input type="text" placeholder="HDFC0001234" formControlName="ifscCode" maxlength="11"
							style="text-transform: uppercase;" autocomplete="off">
					</div>
					@if (isFieldInvalid('ifscCode')) {
					<div class="error-message">{{ getFieldError('ifscCode') }}</div>
					}
				</div>
			</div>
			}

			<!-- Step 2: Amount -->
			@if (step() === 2) {
			<div class="step-main-heading">Amount</div>
			<div class="amount-wrapper">
				<div class="amount-input-box" [class.error]="isFieldInvalid('amount')">
					<div class="row">
						<input type="text" formControlName="amount" class="val-input" placeholder="0.00"
							autocomplete="off" (input)="formatAmount($event)">
						<div class="unit">INR</div>
					</div>
				</div>
				@if (isFieldInvalid('amount')) {
				<div class="error-message amount-error">{{ getFieldError('amount') }}</div>
				}

				<div class="controls-group">
					<div class="available-status">
						<div class="label-val">
							<span>Available</span>
							<span>{{ transferDetails().available }}</span>
						</div>
						<div class="max-tag">MAX</div>
					</div>

					<div class="source-pill">
						<div class="details">
							<div class="name">{{ selectedAccount().name }}</div>
							<div class="meta">{{ selectedAccount().number }}</div>
						</div>
						<div class="change-btn" (click)="toggleAccountDropdown()">
							<span class="text">Change</span>
							<div class="icon">
								<img src="assets/icons/img_direction-down-01.svg" alt="down">
							</div>
						</div>
						<!-- Dropdown (Dynamic Data) -->
						@if (isAccountDropdownOpen()) {
						<div class="account-dropdown">
							@for (acc of sourceAccounts; track acc.number) {
							<div class="dropdown-item" (click)="selectAccount(acc)">
								<div class="acc-name">{{ acc.name }}</div>
								<div class="acc-number">{{ acc.number }}</div>
							</div>
							}
						</div>
						}
					</div>
				</div>

				<!-- Add Note Button (Visible when input is hidden) -->
				@if (!isNoteInputVisible()) {
				<div class="note-pill-btn" (click)="toggleNoteInput()">
					<div class="icon">
						<img src="assets/icons/img_pencil.svg" alt="pencil">
					</div>
					<div class="text">Add a Note</div>
				</div>
				}

				<!-- Note Input Field (Visible when button is hidden) -->
				@if (isNoteInputVisible()) {
				<div class="note-input-container">
					<input type="text" placeholder="Write a note..." class="note-input" autofocus>
					<div class="close-note" (click)="toggleNoteInput()">
						<img src="assets/icons/img_remove.svg" alt="close"
							style="width: 14px; height: 14px; opacity: 0.6;">
					</div>
				</div>
				}
			</div>
			}

			<!-- Step 3: Review -->
			@if (step() === 3) {
			<div class="review-list">
				<div class="review-item-row">
					<div class="label">Account Number</div>
					<div class="value">{{ transferDetails().accountNumber }}</div>
				</div>
				<div class="row-divider"></div>
				<div class="review-item-row">
					<div class="label">Card</div>
					<div class="value">{{ transferDetails().card }}</div>
				</div>
				<div class="row-divider"></div>
				<div class="review-item-row">
					<div class="label">Amount</div>
					<div class="value">₹{{ finalAmount() }}</div>
				</div>
				<div class="row-divider"></div>
				<div class="review-item-row">
					<div class="label">IFSC Code</div>
					<div class="value">{{ transferDetails().ifsc }}</div>
				</div>
				<div class="row-divider"></div>
				<div class="review-item-row">
					<div class="label">Fee</div>
					<div class="value">₹{{ transferDetails().fee }}</div>
				</div>
				<div class="row-divider"></div>
				<div class="review-item-row">
					<div class="label">Recipient Name</div>
					<div class="value">{{ recipientName() }}</div>
				</div>
			</div>
			}

			<!-- Step 4: Security -->
			@if (step() === 4) {
			<div class="row-divider" style="margin: 0 -12px; width: calc(100% + 24px);"></div>
			<div class="pin-grid-container">
				<div class="pin-label">UPI PIN or OTP</div>
				<div class="pin-groups-wrapper">
					<div class="pin-group">
						@for (control of pinControls.slice(0, 3); track $index) {
						<div class="pin-box" [class.filled]="control.value">
							<input #pinInput type="password" maxlength="1" [formControl]="$any(control)"
								(input)="onPinInput($index, $event)"
								(keydown.backspace)="onPinBackspace($index, $event)" autocomplete="one-time-code"
								inputmode="numeric">
							@if (control.value) {
							<div class="filled-dot"></div>
							}
						</div>
						}
					</div>
					<div class="pin-group">
						@for (control of pinControls.slice(3, 6); track $index) {
						<div class="pin-box" [class.filled]="control.value">
							<input #pinInput type="password" maxlength="1" [formControl]="$any(pinControls[$index + 3])"
								(input)="onPinInput($index + 3, $event)"
								(keydown.backspace)="onPinBackspace($index + 3, $event)" autocomplete="one-time-code"
								inputmode="numeric">
							@if (control.value) {
							<div class="filled-dot"></div>
							}
						</div>
						}
					</div>
				</div>
				@if (isFieldInvalid('pin')) {
				<div class="error-message">
					Please enter a complete 6-digit PIN.
				</div>
				}
				@if (apiError()) {
				<div class="error-message">
					{{ apiError() }}
				</div>
				}
			</div>
			<!-- Actions inside card for Step 4 -->
			<div class="step-inner-actions">
				<button type="button" class="btn-base btn-cancel-security" (click)="prevStep()">
					Cancel
				</button>
				<button type="button" class="btn-base btn-primary-action" (click)="nextStep()">
					Confirm
				</button>
			</div>
			}

			<!-- Step 5: Processing & Success -->
			@if (step() === 5) {
			<div class="success-content-wrapper">

				<!-- PROCESSING HEADER -->
				@if (isProcessing()) {
				<div class="success-header-section">
					<div class="processing-loader-wrapper">
						<div class="overlap-group">
							<div class="footer-icon-wrapper">
								<img class="huge-icon-interface spin-anim" src="assets/icons/img_loading.svg"
									alt="Loading" />
							</div>
							<div class="rectangle"></div>
							<div class="blur-circle"></div>
						</div>
					</div>
					<div class="success-title-main">Transactions Progress</div>
					<div class="success-amount-main">₹{{ finalAmount() }}</div>
				</div>
				}

				<!-- SUCCESS HEADER -->
				@if (!isProcessing()) {
				<div class="success-header-section">
					<div class="overlap-group">
						<img class="huge-icon-interface" src="assets/icons/Frame 1996664347.png" alt="Success" />
					</div>
					<div class="success-title-main">Successfully!</div>
					<div class="success-amount-main">₹{{ finalAmount() }}</div>
				</div>
				}

				<!-- Details Section (Shared) -->
				<div class="success-details-wrapper">
					<div class="compact-review-card">
						<div class="review-item-row">
							<div class="label s5-label">Card</div>
							<div class="value s5-value">{{ transferDetails().card }}</div>
						</div>
						<div class="row-divider s5-divider"></div>
						<div class="review-item-row">
							<div class="label s5-label">Amount</div>
							<div class="value s5-value">₹{{ finalAmount() }}</div>
						</div>
						<div class="row-divider s5-divider"></div>
						<div class="review-item-row">
							<div class="label s5-label">Fee</div>
							<div class="value s5-value">₹{{ transferDetails().fee }}</div>
						</div>
						<div class="row-divider s5-divider"></div>
						<div class="review-item-row">
							<div class="label s5-label">Recipient Name</div>
							<div class="value s5-value">{{ recipientName() }}</div>
						</div>
					</div>
				</div>

				<!-- Done button bottom aligned -->
				<div class="step-inner-actions success-actions">
					<button type="button" class="btn-base btn-primary-action btn-done"
						[class.processing-btn]="isProcessing()" [disabled]="isProcessing()" (click)="confirmCancel()">
						Done
					</button>
				</div>
			</div>
			}
		</form>
	</div>
</div>

<!-- Footer Section (Steps 1-3 only) -->
@if (step() < 4) { <div class="upi-modal-footer">
	<button type="button" class="btn-base btn-back-action" (click)="step() === 1 ? onClose() : prevStep()">
		Back
	</button>
	<button type="button" class="btn-base btn-primary-action" (click)="nextStep()"
		[disabled]="(step() === 1 && !canProceedStep1Signal()) || (step() === 2 && !canProceedStep2Signal())">
		@if (step() === 1) {
		<span>Next</span>
		} @else if (step() === 2) {
		<span>Next</span>
		} @else if (step() === 3) {
		<span>Send</span>
		}
	</button>
	</div>
	}

	<!-- Cancel Confirmation Overlay -->
	@if (showCancelConfirm()) {
	<div class="cancel-confirm-overlay" (click)="$event.stopPropagation()">
		<div class="cancel-confirm-card">
			<div class="confirm-backdrop" (click)="closeCancelConfirm()"></div>
			<div class="cancel-modal">
				<div class="cancel-icon-ring">
					<div class="red-ring-bg">
						<img src="assets/icons/img_combo-shape.svg" alt="cancel" class="cancel-main-icon">
					</div>
				</div>
				<div class="confirm-content">
					<div class="confirm-title">Cancel changes?</div>
					<div class="confirm-subtext">All data will be erased irrevocably.</div>
				</div>
				<div class="confirm-actions">
					<button type="button" class="btn-base btn-close-confirm" (click)="closeCancelConfirm()">
						Close
					</button>
					<button type="button" class="btn-base btn-primary-confirm" (click)="confirmCancel()">
						Cancel
					</button>
				</div>
			</div>
		</div>
	</div>
	}
	</div>